import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "cancel-booking-modal"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "cancel-booking-modal--title" }, " You're about to cancel the booking ", -1)
const _hoisted_3 = { class: "cancel-booking-modal--text" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("a", { href: "mailto:info@probusandcar.com" }, "info@probusandcar.com", -1)
const _hoisted_5 = {
  key: 1,
  class: "cancel-booking-feedback-modal"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "cancel-booking-feedback--title" }, " Tell us your reason for canceling ", -1)
const _hoisted_7 = { class: "cancel-booking-feedback-modal--list" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", null, null, -1)
const _hoisted_10 = ["disabled", "onClick"]

import { useCancelBooking } from '@/store/booking'
import { computed, ref } from "vue";
import BottomModal from "@/components/BottomModal.vue";
import type { Booking } from "@/models/your-bookings";



export default /*#__PURE__*/_defineComponent({
  __name: 'CancelBookingModal',
  props: {
    show: { type: Boolean },
    booking: null
  },
  emits: ["close", "cancelled"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'close'): void;
  (e: 'cancelled'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  show: boolean;
  booking: Booking;
};





const reasons = [
  'Change of dates or destination',
  'Personal reasons/Trip called off',
  'Made bookings for the same dates',
  'I wanted to change location',
  'Want to change car (need more room)',
  'Change in the number of passengers',
]

const cancelConfirmed = ref(false)
const selectedReason = ref()
const modalSize = computed(() => cancelConfirmed.value ? "lg" : undefined)

const { cancelBooking, error, isPending } = useCancelBooking(props.booking.id)


const onSubmit = async () => {
  await cancelBooking(selectedReason.value)
  emit('cancelled')
  emit('close')
}

return (_ctx: any,_cache: any) => {
  const _component_Error = _resolveComponent("Error")!

  return (_openBlock(), _createBlock(BottomModal, {
    show: __props.show,
    onClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('close'))),
    size: _unref(modalSize)
  }, {
    default: _withCtx(() => [
      (!cancelConfirmed.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _hoisted_2,
            _createElementVNode("div", _hoisted_3, [
              (__props.booking.hasCancelFee)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(" As you have cancelled within four hours of initial pickup time a full charge will be applied. ")
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode(" There is no charge this time for canceling the booking. We'll send an email confirming your cancellation to "),
                    _hoisted_4,
                    _createTextVNode(" and to the driver if there is one allocated. ")
                  ], 64))
            ]),
            _createElementVNode("button", {
              class: "btn btn-block btn-cancel cancel-booking-modal--cancel-btn",
              onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (cancelConfirmed.value = true), ["prevent"]))
            }, " Cancel booking "),
            _createElementVNode("button", {
              class: "btn btn-block btn-link",
              onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (emit('close')), ["prevent"]))
            }, " back to booking details ")
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createVNode(_component_Error, { error: _unref(error) }, null, 8, ["error"]),
            _hoisted_6,
            _createElementVNode("div", _hoisted_7, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(reasons, (v, k) => {
                return _createElementVNode("li", {
                  key: k,
                  class: _normalizeClass({ checked: v == selectedReason.value })
                }, [
                  _createElementVNode("a", {
                    href: "#",
                    onClick: _withModifiers(($event: any) => (selectedReason.value = v), ["prevent"])
                  }, [
                    _createTextVNode(_toDisplayString(v) + " ", 1),
                    _hoisted_9
                  ], 8, _hoisted_8)
                ], 2)
              }), 64))
            ]),
            _createElementVNode("button", {
              disabled: !selectedReason.value || _unref(isPending),
              onClick: _withModifiers(onSubmit, ["prevent"]),
              class: "btn btn-primary btn-block cancel-booking-feedback-modal--send-btn"
            }, " send feedback ", 8, _hoisted_10)
          ]))
    ]),
    _: 1
  }, 8, ["show", "size"]))
}
}

})